/* stylelint-disable selector-max-compound-selectors */
.ux-iws-nb-data-table {
    display: block;

    .ux-mobile-table__accordion-title > span:first-child {
        display: none;
    }

    .ux-iws-nb-data-table__title-cell {
        strong {
            @include font(bold);
            display: block;
        }
    }

    thead {
        th,
        tr {
            background-color: #fff;
            border-right: 0;
            border-left: 0 !important;
            border-color: $color-gray-border !important;
        }
    }

    .ux-table th {
        padding: 10px 10px 20px;
    }

    tbody tr:hover td,
    tbody tr .ux-table__cell--hover {
        background-color: #fff !important;
    }

    tbody tr td:first-child,
    .ux-table--is-fixed thead th:first-child {
        background-color: $color-blue-6 !important;
    }

    .ux-mobile-table__accordion .ux-accordion__title-container {
        background-color: $color-blue-6 !important;
        border-color: transparent !important;
    }

    .ux-mobile-table__accordion
        .ux-accordion__title-container
        ux-icon[name="chevron-down"] {
        padding: 0 10px;
    }

    .ux-table tr td:last-child {
        border-right: 1px solid $color-gray-border !important;
    }
}
